(() => {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      target.focus({ preventScroll: true });
    });
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-video-hero]').forEach((hero) => {
    const video = hero.querySelector('video');
    const toggle = hero.querySelector('[data-video-toggle]');
    const label = hero.querySelector('[data-video-toggle-label]');
    if (!video || !toggle || !label) return;

    const setPaused = (paused) => {
      hero.classList.toggle('is-video-paused', paused);
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      label.textContent = paused ? 'Play video' : 'Pause video';
    };

    const applyMotionPreference = () => {
      if (reducedMotion.matches) {
        video.pause();
        toggle.hidden = true;
        setPaused(true);
        return;
      }

      toggle.hidden = false;
      const playRequest = video.play();
      if (playRequest) playRequest.then(() => setPaused(false)).catch(() => setPaused(true));
    };

    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().then(() => setPaused(false)).catch(() => setPaused(true));
      } else {
        video.pause();
        setPaused(true);
      }
    });

    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', applyMotionPreference);
    applyMotionPreference();
  });
})();
